import { inject, Pipe, PipeTransform, type Signal } from '@angular/core';
import { DownloadService } from '@common/services/download.service';

@Pipe({
  name: 'downloadLoading',
  pure: true
})
export class GetDownloadLoadingPipe implements PipeTransform {
  private readonly downloadService = inject(DownloadService);

  transform(item: unknown): Signal<boolean> {
    return this.downloadService.loading(item);
  }
}
